module.exports = __webpack_public_path__ + "img/service-icon4.8a4ed82f.png";